export const allowedIdType = identity =>
  identity.idTypeCd === "NRIC" ||
  identity.idTypeCd === "ARID" ||
  identity.idTypeCd === "POID";
